var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-widget-loader',
    {
      'dp-widget-loader--active': _vm.active,
      'dp-widget-loader--anchor-top': _vm.anchorTop,
    }
  ],style:(_vm.offsetStyles)},[_c('div',{staticClass:"dp-widget-loader__inner"},[_c('dp-icon',{staticClass:"dp-widget-loader__spin dp-widget-loader__spin-a",attrs:{"name":"settings","animation":"spinning","solid":""}}),_c('dp-icon',{staticClass:"dp-widget-loader__spin dp-widget-loader__spin-b",attrs:{"name":"settings","animation":"spinning-alt","solid":""}}),_c('dp-icon',{staticClass:"dp-widget-loader__spin dp-widget-loader__spin-c",attrs:{"name":"settings","animation":"spinning-alt","size":"small","solid":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }